export const translations = {
  es: {
    header: {
      ctaDesktop: 'Escríbeme por WhatsApp',
      ctaMobileLabel: 'Contactar por WhatsApp',
    },
    hero: {
      badge: '500+ familias montadas',
      headlineAccent: 'De que te monto, te monto.',
      headline: 'Estrena tu carro hoy, aunque no tengas crédito.',
      subheadline:
        'Soy Pedro "Farándula de la Cruz". Ayudo a la comunidad latina de Miami a montarse sin presión, incluso con ITIN o sin historial.',
      benefits: [
        'Aprobación real con ITIN y Pasaporte',
        '0% presión, 100% transparencia',
        'Sal manejando el mismo día',
      ],
      ctaPrimary: 'Escríbeme por WhatsApp ahora',
      ctaSecondary: 'Prefiero que me escribas',
      response: 'Respuesta en minutos. Sin compromiso.',
      videoTitle: 'Clientes que ya lo lograron',
      videoBadge: 'De que te monto, te monto',
      whatsappMessage:
        'Hola Pedro, quiero montarme hoy. Tengo curiosidad sobre las opciones.',
    },
    trust: {
      rating: '4.9/5',
      headline: '500+ familias latinas',
      subheadline: 'estrenaron su carro con mi ayuda',
      testimonials: [
        {
          quote: 'En 2 horas ya estaba manejando.',
          author: 'Jorge, Hialeah',
        },
        {
          quote: 'Pedro me resolvió todo claro y en español.',
          author: 'Andrea, Kendall',
        },
        {
          quote: 'Salí de la deuda y estrené Tucson.',
          author: 'Luis, Miami Gardens',
        },
      ],
    },
    comparison: {
      headline: 'La diferencia está en el proceso',
      subheadline:
        'Muchos dealers te prometen el cielo y te dan un infierno. Aquí hablamos claro desde el principio.',
      badTitle: 'Lo que hacen otros',
      badPoints: [
        'Te hacen ir al dealer para "darte el precio" (mentira)',
        'Te piden social security aunque saben que tienes ITIN',
        'Te presionan para firmar rápido sin leer',
        'Te prometen un pago y terminas pagando el doble',
      ],
      goodTitle: 'Conmigo es diferente',
      goodBadge: 'La Experiencia Pedro',
      goodPoints: [
        'Hablamos por WhatsApp primero, sin vueltas',
        'Especialistas en ITIN y pasaporte (sabemos cómo hacerlo)',
        'Te explico todo en español, paso a paso',
        'Si no te conviene, te lo digo. Prefiero un amigo que una venta.',
      ],
    },
    vehicles: {
      headline: '¿Qué estás buscando hoy?',
      subheadline:
        'Tengo acceso al inventario de Subaru, GMC, Buick, Hummer y Hyundai. Dime qué necesitas y te lo consigo.',
      cta: 'Solicitar cálculo',
      microcopy: 'Respuesta rápida. Sin presión.',
      categories: [
        {
          title: 'Subaru',
          subtitle: 'Primer Auto / Sin Crédito',
          description:
            'Opciones confiables y seguras, ideales para comenzar o para quienes buscan estabilidad y durabilidad.',
          ctaLabel: 'Ver opciones Subaru',
          models: ['Subaru Impreza', 'Subaru Crosstrek', 'Subaru Outback'],
          whatsappMsg:
            'Hola Pedro, me interesa la categoría: Subaru / Primer Auto',
        },
        {
          title: 'GMC / Buick / Hummer',
          subtitle: 'Para la Familia o Uso Fuerte',
          description:
            'Espacio, potencia y seguridad para familias grandes, trabajo o aventuras sin límites.',
          ctaLabel: 'Ver SUVs y Trucks',
          models: [
            'GMC Acadia / Yukon',
            'Buick Enclave',
            'GMC Sierra',
            'Hummer EV',
          ],
          whatsappMsg:
            'Hola Pedro, me interesa la categoría: GMC / Buick / Hummer',
        },
        {
          title: 'Hyundai',
          subtitle: 'Gas Savings & Technology',
          description:
            'Modern technology and efficiency designed to save you money every day.',
          ctaLabel: 'See hybrids',
          models: ['Elantra Hybrid', 'Sonata Hybrid', 'Tucson Hybrid'],
          whatsappMsg: 'Hi Pedro, I am interested in: Hyundai Hybrids',
        },
      ],
    },
    leadForm: {
      headline: '¿Prefieres que yo te escriba?',
      subheadline:
        'Déjame tus datos y te contacto personalmente cuando tenga un momento libre.',
      successTitle: '¡Recibido!',
      successMsg: 'Te escribiré pronto.',
      fields: {
        name: {
          label: 'Nombre',
          placeholder: 'Tu nombre',
          error: 'Por favor ingresa tu nombre',
        },
        phone: {
          label: 'Teléfono (WhatsApp)',
          placeholder: '(305) 000-0000',
          error: 'Por favor ingresa tu teléfono',
        },
        email: {
          label: 'Email',
          placeholder: 'correo@ejemplo.com',
          error: 'Por favor ingresa tu email',
        },
        vehicle: {
          label: 'Vehículo de interés',
          placeholder: 'Selecciona un vehículo',
          error: 'Por favor selecciona un vehículo',
        },
        creditScore: {
          label: '¿Cómo está tu crédito?',
          placeholder: 'Selecciona tu situación',
          error: 'Por favor selecciona tu situación de crédito',
          options: [
            { value: 'no_credit', label: 'No tengo crédito / Soy nuevo' },
            { value: 'poor', label: 'Malo (menos de 580)' },
            { value: 'fair', label: 'Regular (580–669)' },
            { value: 'good', label: 'Bueno (670–739)' },
            { value: 'excellent', label: 'Excelente (740+)' },
          ],
        },
        consent:
          'Acepto ser contactad@ por WhatsApp/SMS/Email sobre mi solicitud. Puedo cancelar cuando quiera.',
        optionalLabel: 'Opcional',
      },
      cta: 'Que Pedro me escriba',
      security: 'Tus datos están 100% seguros y no se comparten.',
    },
    faq: {
      headline: 'Preguntas Frecuentes',
      subheadline: 'Respuestas claras a las dudas reales de nuestra comunidad.',
      ctaTitle: '¿Tienes otra pregunta?',
      ctaText: 'No te quedes con la duda. Escríbeme directo.',
      ctaButton: 'Preguntar por WhatsApp',
      whatsappMsg: 'Hola Pedro, tengo una pregunta que no está en la página.',
      items: [
        {
          question: '¿Puedo comprar si solo tengo ITIN y pasaporte?',
          answer:
            '¡Sí, absolutamente! Somos especialistas en trabajar con ITIN. Tenemos bancos que entienden tu situación y no te penalizan por no tener Social Security. El proceso es igual de rápido y transparente.',
        },
        {
          question: '¿Necesito tener crédito establecido?',
          answer:
            "No. Tenemos programas de 'Primer Comprador' diseñados específicamente para personas sin historial de crédito. Es la mejor manera de empezar a construir tu crédito en este país con un auto nuevo y garantía.",
        },
        {
          question: '¿Cuánto dinero necesito de entrada (Down Payment)?',
          answer:
            'Depende de cada caso, pero mi meta siempre es que entres con lo mínimo posible. A veces es $0, a veces es $1,000. Lo mejor es que hablemos, evaluemos tu perfil y te diga la verdad sin vueltas.',
        },
        {
          question: '¿Aceptan mi auto viejo como parte de pago (Trade-in)?',
          answer:
            'Sí, aceptamos tu auto en cualquier condición. Incluso si todavía lo debes. Yo me encargo de evaluar tu auto y buscar la mejor oferta para que sirva como parte de pago de tu nuevo vehículo.',
        },
        {
          question: '¿Cuánto demora el proceso?',
          answer:
            'Mi objetivo es que salgas manejando el mismo día. Si me escribes por WhatsApp antes de venir, podemos adelantar la pre-aprobación para que cuando llegues al dealer todo sea firmar y celebrar.',
        },
        {
          question: '¿Tiene garantía el vehículo?',
          answer:
            'Todos nuestros vehículos nuevos incluyen garantía de fábrica. Por ejemplo, los Hyundai ofrecen 10 años/100,000 millas en tren motriz, una de las más completas del mercado.',
        },
      ],
    },
    finalCta: {
      badge: 'Pedro "Farándula" de la Cruz',
      headlineAccent: 'Recuerda:',
      headline: 'De que te monto, te monto.',
      subheadline:
        'Hoy mismo puedes estar manejando tu carro nuevo. Deja de darle vueltas y hablemos claro.',
      cta: 'Escríbeme por WhatsApp ahora',
      whatsappMsg: 'Hola Pedro, estoy listo para montarme.',
      footer: 'Sin compromisos. Solo una charla honesta.',
    },
    footer: {
      title: 'Pedro de la Cruz — Fleet Manager, Miami',
      role: 'Especialista en soluciones para la comunidad latina',
      rights: 'Todos los derechos reservados.',
    },
    whatsappButton: {
      label: 'Hablar con Pedro ahora',
    },
  },
  en: {
    header: {
      ctaDesktop: 'Chat with Pedro on WhatsApp',
      ctaMobileLabel: 'Contact via WhatsApp',
    },
    hero: {
      badge: '500+ families helped',
      headlineAccent: "We'll get you driving today.",
      headline:
        "Even if you're new, rebuilding credit, or just getting started.",
      subheadline:
        'I\'m Pedro "Farándula de la Cruz". I help Miami drivers get into the right vehicle with a clear, fast, no-pressure process.',
      benefits: [
        'Approval even without credit history',
        '0% pressure, 100% transparency',
        'Drive away the same day',
      ],
      ctaPrimary: 'Chat with Pedro on WhatsApp',
      ctaSecondary: 'Have Pedro text me',
      response: 'Response in minutes. No pressure.',
      videoTitle: 'Clients who made it happen',
      videoBadge: "We'll get you driving",
      whatsappMessage:
        'Hi Pedro, I want to drive today. I am curious about my options.',
    },
    trust: {
      rating: '4.9/5',
      headline: '500+ families',
      subheadline: 'got their new car with my help',
      testimonials: [
        {
          quote: 'I was driving in 2 hours.',
          author: 'Jorge, Hialeah',
        },
        {
          quote: 'Pedro explained everything clearly.',
          author: 'Andrea, Kendall',
        },
        {
          quote: 'Got out of debt and into a Tucson.',
          author: 'Luis, Miami Gardens',
        },
      ],
    },
    comparison: {
      headline: 'The difference is the process',
      subheadline:
        'Many dealers promise the sky and deliver a headache. Here we speak clearly from the start.',
      badTitle: 'What others do',
      badPoints: [
        'Make you come in just to "get the price" (a lie)',
        'Ask for Social Security when they know you have ITIN',
        'Pressure you to sign fast without reading',
        'Promise one payment and you end up paying double',
      ],
      goodTitle: "With me it's different",
      goodBadge: 'The Pedro Experience',
      goodPoints: [
        'We chat on WhatsApp first, no runarounds',
        'Specialists in ITIN and Passport (we know how)',
        'I explain everything step-by-step',
        "If it's not right for you, I'll tell you. I prefer a friend over a sale.",
      ],
    },
    vehicles: {
      headline: 'What are you looking for today?',
      subheadline:
        "I have access to Subaru, GMC, Buick, Hummer and Hyundai inventory. Tell me what you need and I'll get it.",
      cta: 'Request Quote',
      microcopy: 'Fast response. No pressure.',
      categories: [
        {
          title: 'Subaru',
          subtitle: 'First Car / No Credit',
          description:
            'Reliable and safe options, ideal for starting out or for those seeking stability and durability.',
          ctaLabel: 'See Subaru options',
          models: ['Subaru Impreza', 'Subaru Crosstrek', 'Subaru Outback'],
          whatsappMsg: 'Hi Pedro, I am interested in: Subaru / First Car',
        },
        {
          title: 'GMC / Buick / Hummer',
          subtitle: 'Family or Heavy Duty',
          description:
            'Space, power, and safety for large families, work, or limitless adventures.',
          ctaLabel: 'See SUVs and Trucks',
          models: [
            'GMC Acadia / Yukon',
            'Buick Enclave',
            'GMC Sierra',
            'Hummer EV',
          ],
          whatsappMsg: 'Hi Pedro, I am interested in: GMC / Buick / Hummer',
        },
        {
          title: 'Hyundai',
          subtitle: 'Gas Savings & Technology',
          description:
            'Modern technology and efficiency designed to save you money every day.',
          ctaLabel: 'See hybrids',
          models: ['Elantra Hybrid', 'Sonata Hybrid', 'Tucson Hybrid'],
          whatsappMsg: 'Hi Pedro, I am interested in: Hyundai Hybrids',
        },
      ],
    },
    leadForm: {
      headline: "If you prefer, I'll reach out personally",
      subheadline:
        "Leave your details and I'll contact you personally when I have a free moment.",
      successTitle: 'Received!',
      successMsg: 'I will write to you soon.',
      fields: {
        name: {
          label: 'Name',
          placeholder: 'Your name',
          error: 'Please enter your name',
        },
        phone: {
          label: 'Phone (WhatsApp)',
          placeholder: '(305) 000-0000',
          error: 'Please enter your phone',
        },
        email: {
          label: 'Email',
          placeholder: 'email@example.com',
          error: 'Please enter your email',
        },
        vehicle: {
          label: 'Vehicle of interest',
          placeholder: 'Select a vehicle',
          error: 'Please select a vehicle',
        },
        creditScore: {
          label: 'How is your credit?',
          placeholder: 'Select your situation',
          error: 'Please select your credit situation',
          options: [
            { value: 'no_credit', label: 'No credit history / New' },
            { value: 'poor', label: 'Poor (below 580)' },
            { value: 'fair', label: 'Fair (580–669)' },
            { value: 'good', label: 'Good (670–739)' },
            { value: 'excellent', label: 'Excellent (740+)' },
          ],
        },
        consent:
          'I agree to be contacted via WhatsApp/SMS/Email regarding my request. I can opt out anytime.',
        optionalLabel: 'Optional',
      },
      cta: 'Have Pedro contact me',
      security: 'Your data is 100% secure and never shared.',
    },
    faq: {
      headline: 'Frequently Asked Questions',
      subheadline: 'Clear answers to real questions from our community.',
      ctaTitle: 'Have another question?',
      ctaText: "Don't stay in doubt. Write to me directly.",
      ctaButton: 'Ask on WhatsApp',
      whatsappMsg: 'Hi Pedro, I have a question not on the page.',
      items: [
        {
          question: 'Can I buy if I only have ITIN and passport?',
          answer:
            "Yes, absolutely! We specialize in working with ITIN. We have banks that understand your situation and don't penalize you for not having Social Security. The process is just as fast and transparent.",
        },
        {
          question: 'Do I need established credit?',
          answer:
            "No. We have 'First Time Buyer' programs designed specifically for people with no credit history. It's the best way to start building your credit in this country with a new car and warranty.",
        },
        {
          question: 'How much down payment do I need?',
          answer:
            "It depends on each case, but my goal is always for you to enter with the minimum possible. Sometimes it's $0, sometimes it's $1,000. The best thing is for us to talk, evaluate your profile, and I'll tell you the truth straight up.",
        },
        {
          question: 'Do you accept my old car as trade-in?',
          answer:
            'Yes, we accept your car in any condition. Even if you still owe on it. I take care of evaluating your car and finding the best offer so it serves as part of the payment for your new vehicle.',
        },
        {
          question: 'How long does the process take?',
          answer:
            "My goal is for you to drive away the same day. If you write to me on WhatsApp before coming, we can advance the pre-approval so when you arrive at the dealer it's all about signing and celebrating.",
        },
        {
          question: 'Does the vehicle have a warranty?',
          answer:
            'All our new vehicles include factory warranty. For example, Hyundai offers the best in the industry (10 years/100,000 miles on powertrain).',
        },
      ],
    },
    finalCta: {
      badge: 'Pedro "Farándula" de la Cruz',
      headlineAccent: 'Remember:',
      headline: "We'll get you driving today.",
      subheadline:
        "You could be driving your new car today. Stop spinning your wheels and let's talk.",
      cta: 'Chat with Pedro on WhatsApp',
      whatsappMsg: 'Hi Pedro, I am ready to drive.',
      footer: 'No commitment. Just an honest chat.',
    },
    footer: {
      title: 'Pedro de la Cruz — Fleet Manager, Miami',
      role: 'Specialist in solutions for the Miami community',
      rights: 'All rights reserved.',
    },
    whatsappButton: {
      label: 'Chat with Pedro now',
    },
  },
}
